module.exports = __webpack_public_path__ + "media/placeholder.f13004ee.mp4";